<template>
  <div class="row main-margin">
    <div class="col-md-12" style="margin-top: 20px">
      <div style="width: 50%; display: inline-block; vertical-align: top">
        <h3 style="margin-bottom: 0px">Home</h3>
      </div>
      <div style="width: 50%; display: inline-block">
        <table style="width: 100%; border: 0px solid black; font-size: 12px">

          <tbody>
            <tr>
              <td style="border: 0px solid black; padding: 2px">
                <h3 style="margin-bottom: 0px" class="text-right">{{ $t("app.welcome") }}  {{ this.$store.state.user.nombre }}</h3>
              </td>              
            </tr>
            <tr>
              <td style="border: 0px solid black; padding: 2px">
                <h5 style="margin-bottom: 0px" class="text-right">{{ this.$store.state.user.cliente.razonSocial }}</h5>
              </td>              
            </tr>          

          </tbody>
        </table>
      </div>
    </div>
    <div class="col-md-12">
      <!-- MIS COMPRAS -->
      <template v-if="this.$store.state.loggedIn">
        <car-item-add />
        <h4 class="card-title text-purple" style="margin-top: 15px;">{{ $t("app.general.recent_purchase") }}</h4>
        <ultimas-compras />
      </template>
    </div>
    <div class="col-md-12">
      <!-- COMUNICADOS -->
      <home-slider />
    </div>
    <div class="col-md-12">
      <!-- PEDIDOS ACTIVOS -->
      <template v-if="this.$store.state.loggedIn">
        <h4 class="card-title text-purple">{{ $t("app.general.last_orders") }}</h4>
        <pedidos-activos />
      </template>
    </div>

    <mostrar-sugerencia-compra></mostrar-sugerencia-compra>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  components: {
    UltimasCompras: () => import("./web/components/ultimasCompras"),
    HomeSlider: () => import("./web/components/comunicadoSlider"),
    PedidosActivos: () => import("./web/components/pedidosActivos"),
    CarItemAdd: () => import("./web/components/addItemToCart"),
    MostrarSugerenciaCompra: () => import('./web/components/mostrarSugerenciaCompra'),
  },
  computed: {
    ...mapState([
      'isRecentlyLoggedIn'
    ]),
    nc() {
      return this.$store.state.not_count;
    }
  },
  data() {
    return {};
  },
  async created() {
  },
  async mounted() {
    if (this.isRecentlyLoggedIn) {
      //console.log('isRecentlyLoggedIn')
      //console.log(this.isRecentlyLoggedIn)
      setTimeout(() => {
        EventBus.$emit('mostrar-sugerencia-compra-inicial')
      }, 500)
    }
  },
  methods: {

  }
};
</script>

<style scoped>
.main-margin {
  margin-left: 20px;
}

.shortcut-img {
  width: 50%;
  height: auto;
  cursor: pointer;
}
</style>
